import { render } from "./CustomerStoreOrders.vue?vue&type=template&id=1ddea8d8"
import script from "./CustomerStoreOrders.vue?vue&type=script&lang=js"
export * from "./CustomerStoreOrders.vue?vue&type=script&lang=js"

import "./CustomerStoreOrders.vue?vue&type=style&index=0&id=1ddea8d8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__